/* eslint-disable camelcase */
import React from 'react'

// Local import
import TextField from '../BasicFields/TextField'
import RadioGroup from '../../ui/RadioGroup'
import { updateErrors } from '../SectionField'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import DuplicateIcon from '../../ui/icons/DuplicateIcon'

class DateTime extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: props.question.id,
      context: props.question.context,
      position: props.question.position,
      title: props.question.title,
      mandatory: props.question.mandatory,
      datetime_format: props.question.datetime_format || 'date_and_time',
      errors: props.question.errors || {}
    }
  }

  shouldComponentUpdate(_nextProps, nextState) {
    this.state.errors = updateErrors(this.state.errors, this.props.getErrors)

    return (
      this.state.title !== nextState.title ||
      this.state.datetime_format !== nextState.datetime_format ||
      this.state.mandatory !== nextState.mandatory ||
      this.state.position !== nextState.position ||
      this.state.errors.isNew === true
    )
  }

  componentDidUpdate() {
    this.props.handleQuestionChange(this.state)
  }

  handleChange = event => this.setState({ [event.target.name]: event.target.value })

  handleMandatoryChange = event => this.setState({ mandatory: event.target.checked })

  handleDatetimeFormatChange = value => this.setState({ datetime_format: value })

  render() {
    return (
      <div className="nested-fields ml-2 ml-md-4">
        <div className="d-flex">
          <div className="mr-auto">
            <i className="fas fa-arrows-alt c-pointer" {...this.props.dragHandleProps} />
            {' Question avec date / heure '}
            <DuplicateIcon
              className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
              onClick={this.props.handleQuestionDuplicate(this.state.id)}
            />
          </div>
          <TrashCanIcon
            className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
            onClick={this.props.handleQuestionRemove(this.state.id)}
          />
        </div>
        <RadioGroup
          name={`datetime-mode-${this.state.id}`}
          options={[
            { value: 'date_and_time', label: 'Date & heure' },
            { value: 'only_date', label: 'Date' },
            { value: 'only_time', label: 'Heure' }
          ]}
          value={this.state.datetime_format}
          inline
          onChange={this.handleDatetimeFormatChange}
        />
        <TextField
          name="title"
          value={this.state.title}
          placeholder="Titre de la question..."
          errors={this.state.errors.title}
          onChange={this.handleChange}
        />
        <div className="custom-control custom-switch">
          <input
            id={`mandatory-question-${this.state.id}`}
            type="checkbox"
            className="custom-control-input custom-switch-lg"
            checked={this.state.mandatory}
            onChange={this.handleMandatoryChange}
          />
          <label className="custom-control-label" htmlFor={`mandatory-question-${this.state.id}`}>
            Réponse obligatoire
          </label>
        </div>
      </div>
    )
  }
}

export default DateTime
